export default __webpack_public_path__ + "static/media/glass.4b881df7.png";